import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AdminWidgetBuilder from '../AdminWidgetBuilder';
import '../../styles/DatasetManagement.css';
import '../../styles/DataSources.css';
import '../../styles/DatasetBuilder.css';
import '../../styles/DashboardEditor.css';

/**
 * Add one data source: a live metric (a value pushed and shown as it
 * changes) or a dataset (rows kept for reports and KPIs). Systems Kinspeed
 * connects have packs that define their datasets instead.
 */
const AddDataSourcePage = () => {
  const navigate = useNavigate();
  const [creatingMetric, setCreatingMetric] = useState(false);

  return (
    <div className="dataset-management">
      <nav className="breadcrumb" aria-label="Breadcrumb">
        <Link to="/admin/data-sources">Data sources</Link> / Add data source
      </nav>
      <div className="page-header">
        <div>
          <h2>Add data source</h2>
          <p className="page-subtitle">Choose what kind of data source to add.</p>
        </div>
      </div>

      <ul className="source-kind-grid" aria-label="Kind of data source">
        <li>
          <button type="button" className="source-kind" onClick={() => setCreatingMetric(true)}>
            <strong>Live metric</strong>
            <span>
              A single value your systems push every few seconds or minutes, such as a queue length or whether a service is up.
              Dashboards show it as it changes.
            </span>
          </button>
        </li>
        <li>
          <button type="button" className="source-kind" onClick={() => navigate('/admin/data-sources/datasets/new')}>
            <strong>Dataset</strong>
            <span>
              Rows of records, such as orders, tickets or monthly targets, kept for reports and KPIs. You define its columns,
              then upload a spreadsheet or push rows through the API.
            </span>
          </button>
        </li>
      </ul>

      <p className="source-hint">
        Using HubSpot or another system Kinspeed connects? <Link to="/admin/data-sources/packs">Install its pack</Link> to get its datasets, measures and KPIs ready-made.
      </p>

      {creatingMetric && (
        <AdminWidgetBuilder
          onClose={() => setCreatingMetric(false)}
          onSuccess={() => navigate('/admin/data-sources', { state: { notice: 'Live metric created' } })}
        />
      )}
    </div>
  );
};

export default AddDataSourcePage;
